module.exports = __webpack_public_path__ + "img/MX-B048045B-BS-HQ.4bcc47a6.png";